module.exports = __webpack_public_path__ + "img/getboarded.008d4188.png";